import { cn } from "../../lib/utils.js";

export const INBOX_IMAGE_MAX_HEIGHT_CLASS = "max-h-[min(16rem,50vh)]";
export const INBOX_IMAGE_MAX_WIDTH_CLASS = "max-w-[min(100%,16rem)] max-md:max-w-[min(100%,14rem)]";

/** Compact shell that hugs natural image dimensions once loaded. */
export const INBOX_ATTACHMENT_IMAGE_SHELL_CLASS = cn(
  "relative inline-block overflow-hidden bg-surface-muted",
  INBOX_IMAGE_MAX_WIDTH_CLASS,
  "min-w-[7.5rem] min-h-[5rem]",
);

/** Thumbnail preserves source aspect ratio within inbox bounds. */
export const INBOX_ATTACHMENT_IMAGE_THUMB_CLASS = cn(
  "block h-auto w-auto max-w-full",
  INBOX_IMAGE_MAX_HEIGHT_CLASS,
  "object-contain",
);

/** @deprecated Use INBOX_ATTACHMENT_IMAGE_SHELL_CLASS — kept for status frames. */
export const INBOX_ATTACHMENT_IMAGE_FRAME_CLASS = cn(
  INBOX_ATTACHMENT_IMAGE_SHELL_CLASS,
  "rounded-md",
);
